const eventNames = {
  NOTIFICATION_SUBMIT: 'notificationSubmit',
  NOTIFICATION_AGREE: 'notificationAgree',

  SHIPMENT_CLEAR_ALL_INPUTS: 'shipmentClearAllInputs',
  IMPORT_ORDER_FROM_STORE: 'importOrderFromStore',
  CLEAR_IMPORT_ORDER_FROM: 'clearImportOrderForm',
  SHIPMENT_SUBMIT: 'shipmentSubmit',
  SUBMIT_WHERE_SHIPMENT: 'submitWhereShipment',
  SUBMIT_WHAT_SHIPMENT: 'submitWhatShipment',
  SHIPMENTS_DELETED: 'shipmentsDeleted',
  HIDE_VERIFICATION_PAGE: 'hideVerificationPage',
  OPEN_CHECKOUT_DETAILS: 'openCheckoutDetails',
  HIDE_CHECKOUT_DETAILS: 'hideCheckoutDetails',
  OPEN_SHIPMENT_ORDER_IMPORT: 'openShipmentOrderImport',
  HIDE_ESTIMATE_RESULTS_DETAIL: 'hideEstimateResultsDetail',
  OPEN_ESTIMATE_RESULTS_DETAIL: 'openEstimateResultsDetail',
  VALIDATE_RECEIVERS_ACCOUNT_DETAILS: 'validateReceiversAccountDetails',
  TOGGLE_RECEIVERS_ACCOUNT: 'toggleReceiversAccount',
  ADD_PARTS_BOOK_ITEM: 'addPartsBookItem',
  UPDATE_PACKAGES_SIGNATURE: 'updatePackagesSignature',

  UPDATE_DASHBOARD_WIDGETS_COLUMN: 'updateDashboardWidgetsColumn',
  SORT_DASHBOARD_WIDGETS_POSITION: 'sortDashboardWidgetsPosition',
  DASHBOARD_WIDGET_DATA_LOADED: 'dashboardWidgetDataLoaded',

  CLEAR_ESTIMATE_FORM: 'clearEstimateForm',

  VALIDATE_DOCUMENT_TYPES: 'validateDocumentTypes',

  CONFIRMATION_DIALOG: 'confirmationDialog',
  CONFIRMATION_DIALOG_REJECTED: 'confirmationDialogRejected',

  OPEN_HISTORY_DETAILS: 'openHistoryDetails',
  CLOSE_HISTORY_DETAILS: 'closeHistoryDetails',

  CONTINUE_SCHEDULE_PICKUP: 'continueSchedulePickup',

  FETCH_CARRIER_ACCOUNTS: 'fetchCarrierAccounts',
  SET_INITIAL_INSTALLATION_CARRIER_ACCOUNT: 'setInitialInstallationCarrierAccount',
};

export default eventNames;
